import { render, staticRenderFns } from "./addDepartment.vue?vue&type=template&id=33d94a78&scoped=true&"
import script from "./addDepartment.vue?vue&type=script&lang=js&"
export * from "./addDepartment.vue?vue&type=script&lang=js&"
import style0 from "./addDepartment.vue?vue&type=style&index=0&id=33d94a78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d94a78",
  null
  
)

export default component.exports